import { render, staticRenderFns } from "./ProductsOnOfferCombo.vue?vue&type=template&id=55b993a5&scoped=true"
import script from "./ProductsOnOfferCombo.vue?vue&type=script&lang=js"
export * from "./ProductsOnOfferCombo.vue?vue&type=script&lang=js"
import style0 from "./ProductsOnOfferCombo.vue?vue&type=style&index=0&id=55b993a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b993a5",
  null
  
)

export default component.exports